import { render, staticRenderFns } from "./DatoExtendidoForm.vue?vue&type=template&id=0a838b31&scoped=true&"
import script from "./DatoExtendidoForm.vue?vue&type=script&lang=ts&"
export * from "./DatoExtendidoForm.vue?vue&type=script&lang=ts&"
import style0 from "./DatoExtendidoForm.vue?vue&type=style&index=0&id=0a838b31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a838b31",
  null
  
)

export default component.exports